import { Currency, CurrencyAmount, JSBI, BIG_0 } from '@nominex/nomiswap-sdk'
import { MIN_BNB } from 'config/constants'

/**
 * Given some token amount, return the max that can be spent of it
 * @param currencyAmount to return max of
 */
export function maxAmountSpend(currencyAmount?: CurrencyAmount<Currency>): CurrencyAmount<Currency> | undefined {
  if (!currencyAmount) {
    return undefined
  }
  if (currencyAmount.currency?.isNative) {
    if (JSBI.greaterThan(currencyAmount.quotient, MIN_BNB)) {
      return CurrencyAmount.fromRawAmount(currencyAmount.currency, JSBI.subtract(currencyAmount.quotient, MIN_BNB))
    }

    return CurrencyAmount.fromRawAmount(currencyAmount.currency, BIG_0)
  }

  return currencyAmount
}
